export default {
      id: "icon-angle-left-usage",
      viewBox: "0 0 8 14",
      url: __webpack_public_path__ + "icons.svg#icon-angle-left",
      toString: function () {
        return this.url;
      }
    }